import { CssBaseline } from '@mui/material'
import type React from 'react'

export const Baseline: React.FC = () => <CssBaseline />
Baseline.displayName = 'Baseline'
